import React, { useState, useEffect } from "react";
import { Spinner, Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { resendActivationMail } from "../../api/SignInAndSignUpAPI";

const RequestVerificationResend = (props: any) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [errors, setErrors] = useState({
    emailError: false,
    emailErrorMsg: "",
  });

  const validate = () => {
    const mailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    let status = {
      emailError: false,
      emailErrorMsg: "",
    };

    if (email === "") {
      status.emailError = true;
      status.emailErrorMsg = "Please enter your email address";
    } else if (!email.match(mailValidate)) {
      status.emailError = true;
      status.emailErrorMsg = "Please enter a valid email address";
    } else {
      status.emailError = false;
      status.emailErrorMsg = "";
    }

    if (status.emailError) {
      setErrors(status);
      return false;
    } else {
      setErrors(status);
      return true;
    }
  };

  const handleResendActivationMail = () => {
    if (validate()) {
      setLoading(true);
      resendActivationMail(
        email,
        (response: any) => {
          setLoading(false);
          toast.success(`Activation mail sent to your email account`);
          props.close();
        },
        (error: any) => {
          setLoading(false);
          toast.error(`Something went wrong. Please try again.`);
          if (error.response && error.response.data) {
            setErrors({
              ...errors,
              emailError: true,
              emailErrorMsg:
                error.response.data.description +
                " | Error: " +
                error.response.data.code,
            });
            toast.error(`${error.response.data.description}. ${error}`);
          } else {
            toast.error(`Something went wrong. Please try again. ${error}`);
          }
        }
      );
    }
  };

  useEffect(() => {
    setEmail(props.emailVal);
  }, [props.emailVal]);

  return (
    <div className="forgot-password-request-section">
      <h4>Resend Activation Email</h4>
      <p>
      Your email has not been verified. Please check your inbox for the verification email or click Resend Activation Email to send it again.
      </p>

      <Form noValidate>
        <Form.Group>
          <Form.Label>Email address</Form.Label>
          <Form.Control
            placeholder="Enter email"
            required
            type="text"
            name="email"
            autoComplete="off"
            isInvalid={errors.emailError}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            {errors.emailErrorMsg}
          </Form.Control.Feedback>
        </Form.Group>

        <Button
          className="pix-main-button"
          type="button"
          onClick={!isLoading ? handleResendActivationMail : () => {}}
        >
          {isLoading ? (
            <>
              <Spinner
                animation="border"
                role="status"
                variant="light"
                size="sm"
              ></Spinner>
              Please wait...
            </>
          ) : (
            "Resend activation email"
          )}
        </Button>
      </Form>
    </div>
  );
};

export default RequestVerificationResend;
